import API from '@/services/api'
import { STORE_ADD_REVISION_TO_DAMAGE } from './damages'

// Actions
export const FETCH_DAMAGE_REVISIONS = 'fetchDamageRevisions'
export const FETCH_DAMAGE_REVISION = 'fetchDamageRevision'
export const CREATE_DAMAGE_REVISION = 'createDamageRevision'
export const UPDATE_DAMAGE_REVISION = 'updateDamageRevision'
export const DELETE_DAMAGE_REVISION = 'deleteDamageRevision'

// Mutations
export const STORE_SET_DAMAGE_REVISIONS = 'storeSetDamageRevisions'
export const STORE_ADD_DAMAGE_REVISION = 'storeSetDamageRevision'
export const STORE_UPDATE_DAMAGE_REVISION = 'storeUpdateDamageRevision'
export const STORE_DELETE_DAMAGE_REVISION = 'storeDeleteDamageRevision'

const state = {
	revisions: [],
}

const getters = {
	revisions (state) {
		return state.revisions
	},
}

const actions = {
	[FETCH_DAMAGE_REVISIONS] (context, options) {
		return new Promise((resolve, reject) => {
			API.query('damages/' + options.location + '/' + options.damage + '/revisions').then((response) => {
				context.commit(STORE_SET_DAMAGE_REVISIONS, response.data)
				resolve(response.data)
			}).catch((response) => {
				reject(response)
			})
		})
	},
	[FETCH_DAMAGE_REVISION] (context, options) {
		return new Promise((resolve, reject) => {
			API.query('damages/' + options.location + '/' + options.damage + '/revisions/' + options.revision).then((response) => {
				resolve(response.data)
			}).catch((response) => {
				reject(response)
			})
		})
	},
	[CREATE_DAMAGE_REVISION] (context, options) {
		return new Promise((resolve, reject) => {
			API.post('damages/' + options.location + '/' + options.damage + '/revisions', options.data).then((response) => {
				context.commit(STORE_ADD_DAMAGE_REVISION, response.data)
				resolve(response.data)
			}).catch(({ response }) => {
				reject(response.data)
			})
		})
	},
	[UPDATE_DAMAGE_REVISION] (context, options) {
		return new Promise((resolve, reject) => {
			API.update('damages/' + options.location + '/' + options.damage + '/revisions', options.revision, options.changes).then((response) => {
				context.commit(STORE_UPDATE_DAMAGE_REVISION, response.data)
				context.commit(STORE_ADD_REVISION_TO_DAMAGE, {
					damage: options.damage,
					revision: response.data,
				})
				resolve(response.data)
			}).catch(({ response }) => {
				reject(response.data)
			})
		})
	},
	[DELETE_DAMAGE_REVISION] (context, options) {
		return new Promise((resolve, reject) => {
			API.delete('damages/' + options.inspection + '/' + options.damage + '/revisions/' + options.revision).then((response) => {
				context.commit(STORE_DELETE_DAMAGE_REVISION, options.damage)
				resolve(response.data)
			}).catch((response) => {
				reject(response)
			})
		})
	},
}

const mutations = {
	[STORE_SET_DAMAGE_REVISIONS] (state, revisions) {
		state.revisions = revisions
	},
	[STORE_ADD_DAMAGE_REVISION] (state, revision) {
		state.revisions.push(revision)
	},
	[STORE_UPDATE_DAMAGE_REVISION] (state, revision) {
		let revisions = []

		state.revisions.map((mapRevision) => {
			if (mapRevision.id === revision.id) {
				mapRevision = revision
			}

			revisions.push(mapRevision)
		})

		state.revisions = revisions
	},
	[STORE_DELETE_DAMAGE_REVISION] (state, revision) {
		state.revisions.splice(state.revisions.indexOf(revision), 1)
	},
}

export default { state, getters, actions, mutations }